import { execAdmin } from '../utils';

const gql = String.raw;

interface DeleteSizePropertyResponse {
  partner: {
    deleteSizeProperty: {
      success: boolean;
      error?: string;
    };
  };
}

interface DeleteSizePropertyVariables {
  partnerCode: string;
  id: number;
}

const DELETE_SIZE_PROPERTY_MUTATION = gql`
  mutation deleteSizeProperty($partnerCode: String!, $id: Int!) {
    partner(code: $partnerCode) {
      deleteSizeProperty(id: $id) {
        success
        error
      }
    }
  }
`;

export const deleteSizeProperty = async ({
  id,
  partnerCode,
  token,
}: {
  id: number;
  partnerCode: string;
  token: string;
}): Promise<void> => {
  const variables: DeleteSizePropertyVariables = {
    partnerCode,
    id,
  };

  const response = await execAdmin<DeleteSizePropertyVariables, DeleteSizePropertyResponse>(
    DELETE_SIZE_PROPERTY_MUTATION,
    { variables }
  );

  if (!response.partner.deleteSizeProperty.success) {
    throw new Error(
      response.partner.deleteSizeProperty.error || 'Failed to delete size property'
    );
  }
};
